const FAPI = window.FAPI;

let appParams = FAPI.Util.getRequestParameters();